module.exports = __webpack_public_path__ + "static/media/IconTemplates_-43.feb667ed.svg";